var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showView && !_vm.$route.meta.public)?[_c('the-filter'),_c('the-toolbar'),_c('the-drawer')]:_vm._e(),(_vm.showView)?_c('the-view'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }